import { MetaFiltersResponse, PredictiveSearchResponse, SearchApiResponse, SearchProfilesResponse } from '../types'
import { getApiClient } from './apiClient'

export const searchFn = async (params: Record<string, unknown>): Promise<SearchApiResponse<SearchProfilesResponse>> => {
  const response = await getApiClient().post('/search', JSON.stringify({ ...params }))
  return response.data
}

export const fetchDateRangeFn = async (): Promise<MetaFiltersResponse> => {
  const response = await getApiClient().get('/search/filters')
  return response.data
}

export const fetchIsContactable = async (rawCompanyIds: number[]) => {
  const companyIds = [...Array.from(new Set(rawCompanyIds.map(id => Number(id))))].filter(Boolean)
  const response = await getApiClient().post('/company/contactable', JSON.stringify({ companyIds }))

  return response.data?.companies?.reduce((acc: Record<string, boolean>, id: number) => ({ ...acc, [id]: true }), {})
}

export const fetchPredictiveSearch = async (input: string): Promise<PredictiveSearchResponse> => {
  const response = await getApiClient().get('/search/predictive', { params: { input } })

  return response.data
}
